/* Demo 3 MPA mode: legacy SPA navigation intentionally disabled. */
(() => { window.__gcSpaReady = true; })();
